/** Draggable column-resize handle pinned to one vertical edge of its (relative) parent. */
import React from 'react';

import { Z } from '@shared/constants/zIndex';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  /** Which edge of the parent the handle pins to. Defaults to 'right'. */
  side?: 'left' | 'right';
  onDoubleClick?: (() => void) | undefined;
}

/** A 1px hit-area that highlights on hover/active; the consumer owns the drag math. */
export const ResizeHandle: React.FC<ResizeHandleProps> = ({ onMouseDown, side = 'right', onDoubleClick }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div
    data-testid="resize-handle"
    className={`group absolute top-0 ${side === 'left' ? 'left-0' : 'right-0'} h-full w-1 cursor-col-resize`}
    style={{ zIndex: Z.STICKY }}
    onMouseDown={onMouseDown}
    {...(onDoubleClick ? { onDoubleClick } : {})}
  >
    <div className="h-full w-full transition-colors group-hover:bg-brand/50 group-active:bg-brand/70" />
  </div>
);
